import Phaser from "phaser";
import { CLASS_NAMES, DIRS, SCALE } from "../../../utils/constants";
import UI from "../../UI";
import BranchChunk from "./BranchChunk";
import Womb from "./Womb";
import EasyStar from "easystarjs";

class Abushgidim {
  constructor(level, position) {
    this.level = level;
    this.position = position;
    this.body = null;
    this.leftBranch = {
      id: "LEFT_BRANCH",
      chunks: [],
      originPos: { x: position.x - 2, y: position.y - 2 },
      damageReceived: 0,
      energy: 50,
      maxEnergy: 50,
      animating: false,
    };
    this.midBranch = {
      id: "MID_BRANCH",
      chunks: [],
      originPos: { x: position.x, y: position.y - 3 },
      damageReceived: 0,
      energy: 50,
      maxEnergy: 50,
      animating: false,
    };
    this.rightBranch = {
      id: "RIGHT_BRANCH",
      chunks: [],
      originPos: { x: position.x + 2, y: position.y - 2 },
      damageReceived: 0,
      energy: 50,
      maxEnergy: 50,
      animating: false,
    };
    this.leftWomb = null;
    this.rightWomb = null;
    this.easystar = new EasyStar.js();
    this.alive = true;

    this.drawEnemy();
    this.subscribeToTicks();
  }

  subscribeToTicks() {
    this.level.onNextTick((lvl) => {
      this.maintenance();
      if (this.alive) {
        this.subscribeToTicks();
      }
    });
  }

  drawEnemy() {
    // this.body = this.level.scene.add
    //   .rectangle(
    //     UI.tileToScreen(this.position.x),
    //     UI.tileToScreen(this.position.y),
    //     UI.tileToScreen(1),
    //     UI.tileToScreen(1),
    //     0xff0000
    //   )
    //   .setOrigin(0, 0);
    this.body = [
      // RIGHT WOMB
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 1) + UI.tileToScreen(0.5)
        )
        .play("bossWombTop")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .play("bossWombBottom1")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .play("bossWombBottom2_idle")
        .setDepth(5.5),
      // LEFT WOMB
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 1) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossWombTop")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossWombBottom1")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossWombBottom2_idle")
        .setDepth(5.5),
      // CENTER
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 2) + UI.tileToScreen(0.5)
        )
        .play("bossCenterTop")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 1) + UI.tileToScreen(0.5)
        )
        .play("bossCenterMid")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .play("bossCenterBottom")
        .setDepth(5.5),
      // RIGHT SIDE
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 2) + UI.tileToScreen(0.5)
        )
        .play("bossSideTop")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 1) + UI.tileToScreen(0.5)
        )
        .play("bossSideMid")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .play("bossSideBottom")
        .setDepth(5.5),
      // RIGHT BORDER
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 2) + UI.tileToScreen(0.5)
        )
        .play("bossBorderTop")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 1) + UI.tileToScreen(0.5)
        )
        .play("bossBorderMid")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x + 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .play("bossBorderBottom")
        .setDepth(5.5),
      // LEFT SIDE
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 2) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossSideTop")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 1) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossSideMid")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 1) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossSideBottom")
        .setDepth(5.5),
      // LEFT BORDER
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 2) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossBorderTop")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y - 1) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossBorderMid")
        .setDepth(5.5),
      this.level.scene.add
        .sprite(0, 0)
        .setOrigin(0.5, 0.5)
        .setScale(SCALE())
        .setPosition(
          UI.tileToScreen(this.position.x - 2) + UI.tileToScreen(0.5),
          UI.tileToScreen(this.position.y) + UI.tileToScreen(0.5)
        )
        .setFlipX(true)
        .play("bossBorderBottom")
        .setDepth(5.5),
    ];

    let branch = new BranchChunk(this, this.leftBranch.id, 0x00ff00);
    branch.setPosition(this.leftBranch.originPos);
    this.leftBranch.chunks.push(branch);
    branch.animGrow();

    branch = new BranchChunk(this, this.midBranch.id, 0x008800);
    branch.setPosition(this.midBranch.originPos);
    this.midBranch.chunks.push(branch);
    branch.animGrow();

    branch = new BranchChunk(this, this.rightBranch.id, 0x00bb00);
    branch.setPosition(this.rightBranch.originPos);
    this.rightBranch.chunks.push(branch);
    branch.animGrow();

    let womb = new Womb(this);
    womb.setPosition({ ...this.position, x: this.position.x - 2 });
    this.leftWomb = womb;

    womb = new Womb(this);
    womb.setPosition({ ...this.position, x: this.position.x + 2 });
    this.rightWomb = womb;
  }

  async growBranches() {
    const grid = this.level.objects.map((row) =>
      row.map((el) => {
        return el.isClass(CLASS_NAMES.GROUND) ||
          el.isClass(CLASS_NAMES.PLAYER) ||
          el.isClass(CLASS_NAMES.EMPTY)
          ? 0
          : 1;
      })
    );
    this.easystar.setAcceptableTiles([0]);

    //===========
    // MID BRANCH
    //===========
    let midPath = [];
    let lastChunk = null;
    if (this.midBranch.energy > 0) {
      // allow path finder to start from branch head position
      lastChunk = this.midBranch.chunks.slice(-1)[0];
      grid[lastChunk.position.y][lastChunk.position.x] = 0; // flags walkable
      this.easystar.setGrid(grid);
      midPath = await this.calcPathForBranch(this.midBranch);
      grid[lastChunk.position.y][lastChunk.position.x] = 1; // restores flag
      // flags new path as invalid
      midPath.forEach((p) => (grid[p.y][p.x] = 1));
    }

    //============
    // LEFT BRANCH
    //============
    let leftPath = [];
    if (this.leftBranch.energy > 0) {
      // allow path finder to start from branch head position
      lastChunk = this.leftBranch.chunks.slice(-1)[0];
      grid[lastChunk.position.y][lastChunk.position.x] = 0; // flags walkable
      this.easystar.setGrid(grid);
      leftPath = await this.calcPathForBranch(this.leftBranch);
      grid[lastChunk.position.y][lastChunk.position.x] = 1; // restores flag
      // flags new path as invalid
      leftPath.forEach((p) => (grid[p.y][p.x] = 1));
    }

    //=============
    // RIGHT BRANCH
    //=============
    let rightPath = [];
    if (this.rightBranch.energy > 0) {
      // allow path finder to start from branch head position
      lastChunk = this.rightBranch.chunks.slice(-1)[0];
      grid[lastChunk.position.y][lastChunk.position.x] = 0; // flags walkable
      this.easystar.setGrid(grid);
      rightPath = await this.calcPathForBranch(this.rightBranch);
      // no need to restore since all pathfinder have been called.
    }

    await this.level.awaitTicksTime(2);

    // =========================================
    // calc focus object by proximity to player
    // =========================================

    // helper
    const gridToPixels = (pos) =>
      pos ? { x: UI.tileToScreen(pos.x), y: UI.tileToScreen(pos.y) } : null;
    const MAX = Number.MAX_SAFE_INTEGER;
    // elements from which to messure the distance
    const midPoint =
      midPath.length > 0
        ? midPath.slice(-1)[0]
        : this.midBranch.chunks.length > 0
        ? // wider range so it can't compete agains a branch that can move, but if noone can move, this will tell the closest to the player
          {
            x: 64 + this.midBranch.chunks.slice(-1)[0].position.x,
            y: 64 + this.midBranch.chunks.slice(-1)[0].position.y,
          }
        : { x: MAX, y: MAX };
    const leftPoint =
      leftPath.length > 0
        ? leftPath.slice(-1)[0]
        : this.leftBranch.chunks.length > 0
        ? // wider range so it can't compete agains a branch that can move, but if noone can move, this will tell the closest to the player
          {
            x: 64 + this.leftBranch.chunks.slice(-1)[0].position.x,
            y: 64 + this.leftBranch.chunks.slice(-1)[0].position.y,
          }
        : { x: MAX, y: MAX };
    const rightPoint =
      rightPath.length > 0
        ? rightPath.slice(-1)[0]
        : this.rightBranch.chunks.length > 0
        ? // wider range so it can't compete agains a branch that can move, but if noone can move, this will tell the closest to the player
          {
            x: 64 + this.rightBranch.chunks.slice(-1)[0].position.x,
            y: 64 + this.rightBranch.chunks.slice(-1)[0].position.y,
          }
        : { x: MAX, y: MAX };
    // distance to player for new branch head or previous branch head in case that easystarjs can't find a path
    const midDistToPlayer = Phaser.Math.Distance.BetweenPoints(
      gridToPixels(midPoint),
      this.level.player.alien
    );
    const leftDistToPlayer = Phaser.Math.Distance.BetweenPoints(
      gridToPixels(leftPoint),
      this.level.player.alien
    );
    const rightDistToPlayer = Phaser.Math.Distance.BetweenPoints(
      gridToPixels(rightPoint),
      this.level.player.alien
    );
    // get the closest to player
    const minDistToPlayer = Math.min(
      midDistToPlayer,
      leftDistToPlayer,
      rightDistToPlayer
    );
    let focusCoords;
    if (minDistToPlayer === midDistToPlayer) {
      // detects if its a point belonging to a non moving brnach, and substract the offset
      focusCoords =
        midPoint.x > 64 ? { x: midPoint.x - 64, y: midPoint.y - 64 } : midPoint;
    }
    if (minDistToPlayer === leftDistToPlayer) {
      // detects if its a point belonging to a non moving brnach, and substract the offset
      focusCoords =
        leftPoint.x > 64
          ? { x: leftPoint.x - 64, y: leftPoint.y - 64 }
          : leftPoint;
    }
    if (minDistToPlayer === rightDistToPlayer) {
      // detects if its a point belonging to a non moving brnach, and substract the offset
      focusCoords =
        rightPoint.x > 64
          ? { x: rightPoint.x - 64, y: rightPoint.y - 64 }
          : rightPoint;
    }
    await this.level.scene.rules.panAndFollow({
      x: UI.tileToScreen(focusCoords.x),
      y: UI.tileToScreen(focusCoords.y),
      width: 1,
      height: 1,
    });

    // closure helper to dispose one by one the position of a path found.
    const nextPosDispenser = (path) => () => path.shift();

    if (
      this.isSamePosition(
        midPath[midPath.length - 1],
        this.level.player.position
      ) ||
      this.isSamePosition(
        leftPath[leftPath.length - 1],
        this.level.player.position
      ) ||
      this.isSamePosition(
        rightPath[rightPath.length - 1],
        this.level.player.position
      )
    ) {
      this.level.playerKilledByBranch();
    }
    // calls animations in parallel, awaits for all to resolve
    await Promise.all([
      this.animateGrow(this.midBranch, nextPosDispenser(midPath)),
      this.animateGrow(this.leftBranch, nextPosDispenser(leftPath)),
      this.animateGrow(this.rightBranch, nextPosDispenser(rightPath)),
    ]);
  }

  async animateGrow(branch, getNextPos) {
    const nextPos = getNextPos();
    if (nextPos && !branch.animating) {
      const chunk = new BranchChunk(this, branch.id, branch.chunks[0].color);
      chunk.setPosition(nextPos);
      branch.chunks.push(chunk);
      await Promise.all(branch.chunks.map((b) => b.animGrow()));
      // await this.level.awaitTicksTime(2);
      await this.animateGrow(branch, getNextPos);
    }
  }

  async animateReduction(branch) {
    if (branch.chunks.length > 1) {
      branch.animating = true;
      await Promise.all(branch.chunks.map((b) => b.animReduction()));
      branch.animating = false;

      const chunk = branch.chunks.pop();
      if(chunk) {
        chunk.animDetachment();
  
        await this.level.awaitTicksTime(0.5);
        this.level.replaceByEmpty(chunk);
      }
    }
  }

  async calcPathForBranch(branch) {
    const lastChunk = branch.chunks.slice(-1)[0];
    const start = lastChunk.position;
    const end = this.level.player.position;

    const path = await this.calcPath(start, end);
    // return path.slice(1, path.length - 1)
    return path.slice(1, 5);
  }

  calcPath(start, end) {
    return new Promise((res) => {
      this.easystar.findPath(start.x, start.y, end.x, end.y, (path) => {
        res(path || []);
      });
      this.easystar.calculate();
    });
  }

  birthBats() {
    // this.createBatLeftUp()
    this.createBatLeftDown();
    // this.createBatRightUp()
    this.createBatRightDown();
  }
  async createBatRightUp() {
    const exitPos = {
      x: this.rightWomb.position.x + 1,
      y: this.rightWomb.position.y - 1,
    };
    const upperBat = this.createBatAt(exitPos);
    if (upperBat) {
      await this.level.awaitTicks(2);
      this.level.moveables.push(upperBat);
    }
  }
  async createBatLeftUp() {
    const exitPos = {
      x: this.leftWomb.position.x - 1,
      y: this.leftWomb.position.y - 1,
    };
    const dir = "CW";
    const upperBat = this.createBatAt(exitPos, dir);
    if (upperBat) {
      // delay enemy activation to avoid collision right after born
      await this.level.awaitTicks(2);
      this.level.moveables.push(upperBat);
    }
  }
  createBatRightDown() {
    const exitPos = {
      x: this.rightWomb.position.x + 1,
      y: this.rightWomb.position.y,
    };
    const lowerBat = this.createBatAt(exitPos);
    if (lowerBat) {
      lowerBat.alien?.setAlpha(0);
      this.body[2].play("bossWombBottom2_birth");
      this.body[2].once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
        this.level.moveables.push(lowerBat);
        this.body[2].play("bossWombBottom2_idle");
        lowerBat.alien?.setAlpha(1);
      });
    } else {
      this.body[2].play("bossWombBottom2_blocked");
      this.body[2].once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
        this.body[2].play("bossWombBottom2_idle");
      });
    }
  }
  createBatLeftDown() {
    const exitPos = {
      x: this.leftWomb.position.x - 1,
      y: this.leftWomb.position.y,
    };
    const dir = "CW";
    const lowerBat = this.createBatAt(exitPos, dir);
    if (lowerBat) {
      lowerBat.alien?.setAlpha(0);
      this.body[5].play("bossWombBottom2_birth");
      this.body[5].once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
        this.level.moveables.push(lowerBat);
        this.body[5].play("bossWombBottom2_idle");
        lowerBat.alien?.setAlpha(1);
      });
    } else {
      this.body[5].play("bossWombBottom2_blocked");
      this.body[5].once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
        this.body[5].play("bossWombBottom2_idle");
      });
    }
  }
  createBatAt(pos, dir = "CCW") {
    const exit = this.level.getObjectAt(pos.x, pos.y);
    if (exit.isClass(CLASS_NAMES.EMPTY)) {
      const enemy = this.level.createEnemyAt(pos);
      enemy.scanDirection = dir;
      return enemy;
    }
  }

  maintenance() {
    if (
      this.midBranch.damageReceived > 0 &&
      this.midBranch.energy > 0 &&
      !this.midBranch.animating
    ) {
      this.animateReduction(this.midBranch);
      this.midBranch.damageReceived--;
      this.midBranch.energy--;
      this.level.scene.events.emit("branch_takes_damage", {
        branchId: this.midBranch.id,
        newValue: this.midBranch.energy / this.midBranch.maxEnergy,
      });
    }
    if (
      this.leftBranch.damageReceived > 0 &&
      this.leftBranch.energy > 0 &&
      !this.leftBranch.animating
    ) {
      this.animateReduction(this.leftBranch);
      this.leftBranch.damageReceived--;
      this.leftBranch.energy--;
      this.level.scene.events.emit("branch_takes_damage", {
        branchId: this.leftBranch.id,
        newValue: this.leftBranch.energy / this.leftBranch.maxEnergy,
      });
    }
    if (
      this.rightBranch.damageReceived > 0 &&
      this.rightBranch.energy > 0 &&
      !this.rightBranch.animating
    ) {
      this.animateReduction(this.rightBranch);
      this.rightBranch.damageReceived--;
      this.rightBranch.energy--;
      this.level.scene.events.emit("branch_takes_damage", {
        branchId: this.rightBranch.id,
        newValue: this.rightBranch.energy / this.rightBranch.maxEnergy,
      });
    }

    if (
      this.midBranch.energy <= 0 &&
      this.leftBranch.energy <= 0 &&
      this.rightBranch.energy <= 0 &&
      !this.defeated
    ) {
      this.defeated = true;
      this.level.destroyObjectsByKind(CLASS_NAMES.ENEMY);
      this.level.playerWon();
    }
  }

  destroyBranch(branch) {
    console.log("branch destroyed");
    branch.chunks.forEach((ch) => {
      ch.animDestroy();
      this.level.replaceByEmpty(ch);
    });
    branch.chunks = [];
  }
  takeBranchDamage(branchId, amount) {
    const branch = this.getBranchById(branchId);
    branch.damageReceived += amount;
    if (branch.damageReceived >= branch.energy && branch.energy > 0) {
      branch.energy = 0;
      this.destroyBranch(branch);
      this.level.scene.events.emit("branch_takes_damage", {
        branchId,
        newValue: 0,
      });
    } else {
      const group = this.level.scene.add.group({
        classType: Phaser.GameObjects.Sprite,
        defaultKey: null,
        defaultFrame: null,
        active: true,
        maxSize: -1,
        runChildUpdate: false,
        createCallback: null,
        removeCallback: null,
        createMultipleCallback: null,
      });
      // FLASH BRANCH
      group.addMultiple(branch.chunks.map((ch) => ch.alien));
      const flash = this.level.scene.plugins
        .get("rexFlash")
        .add(group, { duration: 75, repeat: 3 });
      flash.flash();
      flash.once("complete", () => group.clear());
    }
  }

  // branches helpers
  getBranchById(branchId) {
    return [this.leftBranch, this.midBranch, this.rightBranch].find(
      (b) => b.id === branchId
    );
  }
  chunkIsHead(chunk, brachId) {
    const branch = this.getBranchById(brachId);
    return branch.chunks[branch.chunks.length - 1] === chunk;
  }
  chunkIsNeck(chunk, brachId) {
    const branch = this.getBranchById(brachId);
    return (
      branch.chunks.length > 1 &&
      branch.chunks[branch.chunks.length - 2] === chunk
    );
  }
  isSamePosition(posA, posB) {
    return posA && posB && posA.x === posB.x && posA.y === posB.y;
  }
  getChunkOrientation(chunk, branchId) {
    const branch = this.getBranchById(branchId);
    const chunkIdx = branch.chunks.findIndex((ch) => ch === chunk);
    // is head when is not into the branch (after creation before insert) or is last element.
    // const isHead = chunkIdx === -1 || chunkIdx === branch.chunks.length - 1
    const isBase = chunkIdx === 0 || branch.chunks.length === 0;
    if (isBase) {
      return DIRS.UP;
    }
    const prevChunk =
      chunkIdx === -1
        ? branch.chunks[branch.chunks.length - 1]
        : branch.chunks[chunkIdx - 1];
    if (
      prevChunk.position.x < chunk.position.x &&
      prevChunk.position.y === chunk.position.y
    ) {
      return DIRS.RIGHT;
    }
    if (
      prevChunk.position.x > chunk.position.x &&
      prevChunk.position.y === chunk.position.y
    ) {
      return DIRS.LEFT;
    }
    if (
      prevChunk.position.x === chunk.position.x &&
      prevChunk.position.y < chunk.position.y
    ) {
      return DIRS.DOWN;
    }
    if (
      prevChunk.position.x === chunk.position.x &&
      prevChunk.position.y > chunk.position.y
    ) {
      return DIRS.UP;
    }
  }
  isElbow(chunk, branchId) {
    const branch = this.getBranchById(branchId);
    const chunkIdx = branch.chunks.findIndex((ch) => ch === chunk);
    // is head when is not into the branch (after creation before insert) or is last element.
    const isHead = chunkIdx === -1 || chunkIdx === branch.chunks.length - 1;
    const isBase = chunkIdx === 0 || branch.chunks.length === 0;
    if (isHead) {
      return false;
    }
    const nextChunk = branch.chunks[chunkIdx + 1];
    // if it's base, mock chunk below to make this alwas DIRS.UP
    const prevChunk = isBase
      ? { ...chunk, position: { ...chunk.position, y: chunk.position.y + 1 } }
      : branch.chunks[chunkIdx - 1];
    if (
      prevChunk.position.x < nextChunk.position.x &&
      prevChunk.position.y > nextChunk.position.y
    ) {
      if (prevChunk.position.x < chunk.position.x) {
        //  x
        // o╝
        return DIRS.RIGHT + DIRS.UP;
      } else {
        // ╔x
        // o
        return DIRS.UP + DIRS.RIGHT;
      }
    }
    if (
      prevChunk.position.x < nextChunk.position.x &&
      prevChunk.position.y < nextChunk.position.y
    ) {
      if (prevChunk.position.x < chunk.position.x) {
        // o╗
        //  x
        return DIRS.RIGHT + DIRS.DOWN;
      } else {
        // o
        // ╚x
        return DIRS.DOWN + DIRS.RIGHT;
      }
    }
    if (
      prevChunk.position.x > nextChunk.position.x &&
      prevChunk.position.y < nextChunk.position.y
    ) {
      if (prevChunk.position.x > chunk.position.x) {
        // ╔o
        // x
        return DIRS.LEFT + DIRS.DOWN;
      } else {
        //  o
        // x╝
        return DIRS.DOWN + DIRS.LEFT;
      }
    }
    if (
      prevChunk.position.x > nextChunk.position.x &&
      prevChunk.position.y > nextChunk.position.y
    ) {
      if (prevChunk.position.x > chunk.position.x) {
        // x
        // ╚o
        return DIRS.LEFT + DIRS.UP;
      } else {
        // x╗
        //  o
        return DIRS.UP + DIRS.LEFT;
      }
    }

    // after all, if no condition matches, return false since is no elbow
    return false;
  }
}

export default Abushgidim;
